import { useEffect, useState } from "react";
import AddEditAppVersion from "./AddEditAppVersion";
import { getAppVersionApi } from "../../controller";
import Layout from "../../layout/Layout";
import { requestHandler } from "../../helper";

function AppVersion() {
    const [show, setShow] = useState(false);
    const [isEdit, setIsEdit] = useState(false);
    const [formData, setFormData] = useState({});

    const getAppVersionData = async () => {
        requestHandler(
            async () => await getAppVersionApi(),
            null,
            (res) => {
                setFormData(res.data || {});
            },
            (err) => {
                // toast.error(err.message);
            }
        )
    }

    useEffect(() => {
        getAppVersionData();
    }, []);

    // Callback to refresh data after modal save
    const handleAppVersionSaved = () => {
        getAppVersionData();
    };

    return (
        <>
            {/* {loading && <Loader />} */}
            <Layout>
                <div className="row g-3">
                    <div className="col-12">
                        <div className="card-wrapper app-version">
                            <div className="card-body">
                                <div className="custom-card-header">
                                    <div className="d-flex justify-content-between align-items-center gap-3">
                                        <h5>Android</h5>
                                        <button
                                            type="button"
                                            className="btn btn-outline-secondary d-flex align-items-center"
                                            onClick={() => {
                                                setShow(true);
                                                setIsEdit(false);
                                            }}
                                        >
                                            <img src="/images/svg/edit.svg" alt="" />
                                            Edit
                                        </button>
                                    </div>
                                </div>

                                <div className="version-content">
                                    <div className="row mb-3">
                                        <div className="col-sm-3 col-lg-2">
                                            <span className="version-label">Optional Version Update:</span>
                                        </div>
                                        <div className="col-sm-9 col-lg-10">
                                            <span className="version-value">{formData.androidOptionalUpdate || '-'}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-sm-3 col-lg-2">
                                            <span className="version-label">Mandatory Version Update:</span>
                                        </div>
                                        <div className="col-sm-9 col-lg-10">
                                            <span className="version-value">{formData.androidMandatoryUpdate || '-'}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-0">
                                        <div className="col-sm-3 col-lg-2">
                                            <span className="version-label">App Link:</span>
                                        </div>
                                        <div className="col-sm-9 col-lg-10">
                                            <span className="version-value version-link">{formData.androidAppLink || '-'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-12">
                        <div className="card-wrapper app-version">
                            <div className="card-body">
                                <div className="custom-card-header">
                                    <h5>iOS</h5>
                                </div>

                                <div className="version-content">
                                    <div className="row mb-3">
                                        <div className="col-sm-3 col-lg-2">
                                            <span className="version-label">Optional Version Update:</span>
                                        </div>
                                        <div className="col-sm-9 col-lg-10">
                                            <span className="version-value">{formData.iosOptionalUpdate || '-'}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-3">
                                        <div className="col-sm-3 col-lg-2">
                                            <span className="version-label">Mandatory Version Update:</span>
                                        </div>
                                        <div className="col-sm-9 col-lg-10">
                                            <span className="version-value">{formData.iosMandatoryUpdate || '-'}</span>
                                        </div>
                                    </div>
                                    <div className="row mb-0">
                                        <div className="col-sm-3 col-lg-2">
                                            <span className="version-label">App Link:</span>
                                        </div>
                                        <div className="col-sm-9 col-lg-10">
                                            <span className="version-value version-link">{formData.iosAppLink || '-'}</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Layout >

            <AddEditAppVersion show={show} setShow={setShow} isEdit={isEdit} formData={formData} onSaved={handleAppVersionSaved} />

        </>
    )
}

export default AppVersion